import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { useEffect } from "react";
import CountUp from "react-countup";
import { FaStar, FaPuzzlePiece, FaTrophy } from "react-icons/fa";

const FloatingStatsForLandingPage = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ threshold: 0.2 });

  useEffect(() => {
    if (inView) controls.start("visible");
  }, [controls, inView]);

  const stats = [
    {
      number: 4.9,
      suffix: "",
      label: "Average Rating",
      decimal: 1,
      icon: <FaStar className="text-yellow-400" />,
    },
    {
      number: 500,
      suffix: "+",
      label: "Creative Puzzles",
      icon: <FaPuzzlePiece className="text-purple-400" />,
    },
    {
      number: 100,
      suffix: "+",
      label: "Educator Awards",
      icon: <FaTrophy className="text-cyan-400" />,
    },
  ];

  return (
    <motion.div
      ref={ref}
      className="grid grid-cols-3 gap-2 md:gap-8 max-w-6xl mx-auto"
      initial="hidden"
      animate={controls}
    >
      {stats.map((stat, index) => (
        <motion.div
          key={stat.label}
          className="relative p-3 md:p-8 rounded-2xl md:rounded-3xl overflow-hidden"
          variants={{
            hidden: { opacity: 0, y: 30, scale: 0.9 },
            visible: {
              opacity: 1,
              y: 0,
              scale: 1,
              transition: {
                delay: index * 0.2,
                type: "spring",
                stiffness: 80,
              },
            },
          }}
          whileHover="hover"
        >
          {/* Card content */}
          <div className="relative z-10 flex flex-col items-center text-center">
            <motion.div
              className="text-xl md:text-5xl mb-2 md:mb-4"
              animate={{
                y: [-3, 3, -3],
                transition: {
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                },
              }}
            >
              {stat.icon}
            </motion.div>

            <div className="space-y-1 md:space-y-2">
              <div className="text-base md:text-4xl font-bold text-cyan-100">
                <CountUp
                  end={stat.number}
                  suffix={stat.suffix}
                  decimals={stat.decimal || 0}
                  duration={2.5}
                  separator=","
                />
              </div>
              <div className="text-xs md:text-base font-semibold text-cyan-300 tracking-wide uppercase">
                {stat.label}
              </div>
            </div>
          </div>

          {/* Animated border */}
          <motion.div
            className="absolute inset-0 rounded-2xl md:rounded-3xl border pointer-events-none"
            variants={{
              hover: {
                borderColor: ["#22d3ee", "#a855f7", "#22d3ee"],
                transition: {
                  duration: 2,
                  repeat: Infinity,
                },
              },
            }}
            initial={{ borderColor: "rgba(34,211,238,0.2)" }}
          />
        </motion.div>
      ))}
    </motion.div>
  );
};

export default FloatingStatsForLandingPage;
